export default __webpack_public_path__ + "static/media/linux_original_logo_icon_146433.87173a8c.svg";